import React, {useState, useEffect} from 'react'
import JSONEditor from './JSONEditor'
import AppData from '../../app.json';
import StepList from './StepList'
import StepEditForm from './StepEditForm'
import config from '../../config.json'
import Axios from 'axios'
import qs from 'qs';


const Editor = props => {
  const [mode, setMode] = useState('forms');
  const [confirmCommit, setConfirmCommit] = useState(false);
  const [commitMessage, setCommitMessage] = useState('');
  const [saving, setSaving] = useState({
    message: "Save Changes"
  });

  const parseParentGuid = () => {
    return window.parent.location.href.split('/').slice(-1)[0];
  }

  const commitChanges = () => {
    if (config.repoURL) {
      setSaving({
        message: "Saving..."
      });
      const postBody = {
        projectID: parseParentGuid(),
        path: props.controller.getContentURL(),
        data: JSON.stringify(props.controller.getContentData(), null, 2),
        message: `CMS Editor - ${commitMessage}`,
        repoURL: 'https://api.bitbucket.org/2.0/repositories/Allen_Interactions/' + config.repoURL,
      }
      console.log('POSTING...', postBody);

      Axios.post('https://clients.alleni.com/Api/content',
        qs.stringify(postBody),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res) => {
        console.log('res', res)
        setSaving({
          message: "Saved!"
        })
      }).catch((err) => {
        console.log('SAVE ERROR ', err);
        setSaving({
          message: "Error"
        })
      })
    }
  }

  return (
    <div className="Editor">

      <div className="header-bar">
        <h1>
          Course Editor
        </h1>
      </div>

      <div className="flex-wrapper">
        <div className={`step-selection-wrapper`}>
          {
            AppData.modules.map((mod, modIndex) => {
              return <div className={`module ${props.moduleIndex === modIndex ? 'selected' : ''}`}>
                <div className="lesson-label" onClick={() => {props.controller.setModuleIndex(modIndex)}}>
                  <span className="green">{modIndex >= 10 ? modIndex : '0' + modIndex}</span> {`${mod.name}`}
                </div>
                {
                  (props.moduleIndex === modIndex) &&
                  <StepList
                    {...props}
                  />
                }
              </div>
            })
          }
        </div>

        <div className="editor-wrapper">
          {/* <div className={`mode-tabs`}>
                        <div className={`tab ${mode === 'forms' ? 'current' :''}`} onClick={()=>setMode('forms')}>Forms</div>
                        <div className={`tab ${mode === 'raw' ? 'current' :''}`} onClick={()=>setMode('raw')}>Raw</div>
                    </div> */}
          {
            mode === 'raw' &&
            <JSONEditor
              key={`${props.moduleIndex}-${props.stepIndex}`}
              data={props.contentData}
              controller={props.controller}/>
          }
          {
            mode === 'forms' &&
            AppData.modules[props.moduleIndex] &&
            props.stepIndex !== -1 &&

            <StepEditForm
              key={`${props.moduleIndex} - ${props.stepIndex} - editform`}
              url={AppData.modules[props.moduleIndex].source}
              commitChanges={commitChanges}
              saving={saving}
              {...props}
            />
          }
        </div>
      </div>

      {confirmCommit && <div className={`modal`}>
        <div className={`scrim`}></div>
        <div className="popup-body">
          <p>
            Please enter a brief commit message explaining the changes you have made.
          </p>

          <div>
            <div className="field-label">
              Changes Made:
            </div>
            <textarea value={commitMessage}/>
          </div>
          <div>
            <div className="field-label">
              Email:
            </div>
            <input type='email' value=''/>
          </div>
        </div>

      </div>}
    </div>
  )
}

export default Editor